export default "__VITE_ASSET__f579c34c__"